import { render } from "./PointsEarnedPopup.vue?vue&type=template&id=31f23165&scoped=true"
import script from "./PointsEarnedPopup.vue?vue&type=script&lang=js"
export * from "./PointsEarnedPopup.vue?vue&type=script&lang=js"

import "./PointsEarnedPopup.vue?vue&type=style&index=0&id=31f23165&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f23165"]])

export default __exports__